<template>
    <div v-if="config" class="w-full">
        <setting-card
            v-bind="binds"
            @updateProfile="updateProfile()"
            :hideMoreVert="true"
            :hidePrevious="true"
            v-model:active="config.stock"
        >
            <v-row no-gutters class="d-flex justify-center" style="min-width: 650px">
                <v-col cols="8" class="pb-2 text-h6 pl-3">
                    Option pour la gestion des stocks
                </v-col>
                <v-col cols="8">
                    <v-row no-gutters class="rounded-xl border-thin px-2">
                        <v-col cols="9" class="d-flex align-center">
                            Uniquement l'inventaire
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateConfiguration()"
                                v-model="config.stockConfig.onlyInventory"
                            />
                        </v-col>
                        <!-- <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="9" class="d-flex align-center">
                            Tâches IS auto
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch
                                @click="updateProfile()"
                                inset dense
                                v-model="config.autoTaxTask"
                                color="primary"
                            ></v-switch>
                        </v-col> -->
                    </v-row>
                </v-col>
            </v-row>
        </setting-card>
    </div>
</template>

<script lang="ts">
import SettingCard from "../SettingCard.vue";
import Workflow from "../../admin/Workflow.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        SettingCard,
        Workflow,
    },
    emits: ["updateProfile"],
})
export class SettingStock extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) payActions: string;

    get binds() {
        return {
            title: "Stocks",
            partnerName: "bobbee",
            text: "Activez la gestion des stocks et paramétrez les options",
        };
    }

    updateConfiguration() {
        if (!this.config.stock) {
            this.config.stock = true;
        }
        this.updateProfile();
    }

    updateProfile() {
        if (!this.config.stock) {
            this.config.stockConfig.onlyInventory = false;
        }
        this.$emit("updateProfile");
    }
}

export default toNative(SettingStock);
</script>
